//ro-assist-brd1-5
export const OUTSIDE_BASE_PATH = "organizationInfo";
export const BASE_ADDRESS_PATH_1 = "prospect.organizationInfo.addressInfo[0]";
export const BASE_PATH_1 = "prospect.organizationInfo.addressInfo[0].addressDetails[0]";
export const BASE_PATH_2 = "prospect.organizationInfo.addressInfo[1].addressDetails[0]";

export const OTHER_OPTION_CODE = "6";

export const MAX_OFFICE_NUMBER_LENGTH = 10;
export const MAX_STREET_NUMBER_LENGTH = 49;
export const MAX_PO_BOX_NUMBER_LENGTH = 10;
export const MAX_OTHER_FIELD_LENGTH = 50;
export const MAX_FLAT_NUMBER_LENGTH = 50;

export const MAX_BANK_NAME_LENGTH = 150;

export const VIRTUAL_ADDRESS = "virtual";
export const PHYSICAL_ADDRESS = "physical";

export const ISLAMIC_DAC_LINK =
  "https://www.rakbank.ae/en/islamic/business/digital-banking/get-started/digital-access-card";
export const CONVENTIONAL_DAC_LINK =
  "https://www.rakbank.ae/en/business/digital-banking/get-started/digital-access-card";
